module.exports = __webpack_public_path__ + "static/media/ic-gas.3e4d6d0f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Equipments/images/ic-gas.svg
// module id = 1230
// module chunks = 0